import React from 'react';

import NodePartnerCard from '../../../../../implementations/Node/Partner/Card';
import type { SearchAllContentPartnerHit } from '../../../../SearchAllContent/types';

const MetaSearchPartnerHit: React.FC<{ hit: SearchAllContentPartnerHit }> = ({ hit }) => (
  <NodePartnerCard
    title={hit.page_title[0]}
    link={hit.url[0]}
  />
);

export default MetaSearchPartnerHit;
